/* SENTYR — el-hp.js : filet de sécurité pour la page d'accueil.
   Le socle (el-common.js) initialise déjà Slick ([data-slider-config]), les FAQ (.el-question) et les vidéos UGC (.el-play-button).
   Ce fichier ne fait que : (1) initialiser un slider qui ne l'aurait pas été (idempotent), (2) brancher FAQ/vidéo UNIQUEMENT si aucun
   gestionnaire délégué n'existe déjà (pas de double toggle). */
(function () {
  if (window.__elHpLifecycleBound) return;
  window.__elHpLifecycleBound = true;
  var compositionMedia = window.matchMedia ? window.matchMedia('(max-width: 915px)') : null;
  var compositionFrame = 0;

  function hasDelegated(selector) {
    try {
      var ev = window.jQuery && jQuery._data(document, 'events');
      if (!ev || !ev.click) return false;
      return ev.click.some(function (h) { return h.selector === selector; });
    } catch (e) { return false; }
  }
  function initSliders(selector) {
    if (!window.jQuery || !jQuery.fn || !jQuery.fn.slick) return false;
    document.querySelectorAll(selector || '.el-hp-section [data-slider-config]').forEach(function (el) {
      var isComposition = !!el.closest('.el-ingredient-slider');
      if (isComposition && (compositionMedia ? !compositionMedia.matches : window.innerWidth > 915)) return;
      if (el.classList.contains('slick-initialized')) return;
      try {
        var config = JSON.parse(el.dataset.sliderConfig);
        if (isComposition && Array.isArray(config.responsive)) {
          config.responsive.forEach(function (entry) {
            if (entry.breakpoint === 915 && entry.settings !== 'unslick') entry.breakpoint = 916;
          });
        }
        jQuery(el).slick(config);
      } catch (e) { console.warn('el-hp slider', e); }
    });
    return true;
  }
  function onCompositionMediaChange(event) {
    if (!event.matches || compositionFrame) return;
    compositionFrame = window.requestAnimationFrame(function () {
      compositionFrame = 0;
      initSliders('.el-hp-section .el-ingredient-slider [data-slider-config]');
    });
  }
  function bindFallbacks() {
    if (window.__elHpBound) return;
    window.__elHpBound = true;
    if (!hasDelegated('.el-question')) {
      document.addEventListener('click', function (e) {
        var q = e.target.closest('.el-hp-section .el-question');
        if (!q) return;
        var open = q.classList.contains('active');
        document.querySelectorAll('.el-hp-section .el-question.active').forEach(function (o) {
          o.classList.remove('active'); if (o.nextElementSibling) o.nextElementSibling.style.display = 'none';
        });
        if (!open) { q.classList.add('active'); if (q.nextElementSibling) q.nextElementSibling.style.display = 'block'; }
      });
    }
    if (!hasDelegated('.el-play-button')) {
      document.addEventListener('click', function (e) {
        var b = e.target.closest('.el-hp-section .el-play-button');
        if (!b) return;
        var w = b.closest('.el-video-wrapper'); var v = w && w.querySelector('video');
        if (!v) return;
        if (w.classList.contains('active')) { w.classList.remove('active'); v.pause(); }
        else { w.classList.add('active'); v.play(); }
      });
    }
  }
  function boot() {
    var tries = 0;
    (function tick() {
      if (initSliders() || tries++ > 40) { bindFallbacks(); return; }
      setTimeout(tick, 250);
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', function () { initSliders(); });
  document.addEventListener('shopify:section:load', function () { initSliders(); });
  if (compositionMedia) {
    if (compositionMedia.addEventListener) compositionMedia.addEventListener('change', onCompositionMediaChange);
    else if (compositionMedia.addListener) compositionMedia.addListener(onCompositionMediaChange);
  }
})();
